import { GET_LAST_TASK, GET_LAST_TASK_SUCCESS, GET_LAST_TASK_ERROR} from './actionTypes';

const initialState = {
    errorGetLastTask: "",
    loadingGetLastTask: false,
    lastTask: null,
    successLastTask: ""
}

const getLastTask = (state = initialState, action) => {
    switch (action.type) {
        case GET_LAST_TASK:
            state = {
                ...state,
                loadingGetLastTask: true
            }
            break;
        case GET_LAST_TASK_SUCCESS:
            state = {
                ...state,
                loadingGetLastTask: false,
                lastTask: action.payload.lastTask, 
                successLastTask: action.payload.message
            }
            break;
        case GET_LAST_TASK_ERROR:
            state = { ...state, errorGetLastTask: action.payload, loadingGetLastTask: false };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default getLastTask;